
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import { ValidationErrors } from "./hooks/useFormValidation";

interface ValidationErrorsAlertProps {
  errors: ValidationErrors;
}

export const ValidationErrorsAlert = ({ errors }: ValidationErrorsAlertProps) => {
  if (Object.keys(errors).length === 0) return null;

  return (
    <Alert variant="destructive" className="mb-4">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>
        Please fix the following issues:
        <ul className="list-disc pl-4 mt-2">
          {Object.entries(errors).map(([key, error]) => (
            <li key={key}>{error}</li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  );
};
